// eslint-disable-next-line unicorn/prefer-native-coercion-functions
export const isTruthy = (x) => Boolean(x);
//# sourceMappingURL=isTruthy.js.map